import { render, staticRenderFns } from "./addksFileTabledept.vue?vue&type=template&id=a3fbadd2&scoped=true"
import script from "./addksFileTabledept.vue?vue&type=script&lang=js"
export * from "./addksFileTabledept.vue?vue&type=script&lang=js"
import style0 from "./addksFileTabledept.vue?vue&type=style&index=0&id=a3fbadd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fbadd2",
  null
  
)

export default component.exports